import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle, UncontrolledTooltip } from "reactstrap";
import { AiCheckMissingFields } from "../../../../../constants";

const MissingChart = ({ t, id, missingData, title, helpText, threshold = 30 }) => {
    const { categories, values, colors } = useMemo(() => {
        if (!missingData || typeof missingData !== "object") {
            return { categories: [], values: [], colors: [] };
        }

        const items = Object.entries(missingData)
            .map(([k, v]) => ({ key: k, value: Number(v.pct) || 0 }))
            .filter((item) => item.value > 0);

        items.sort((a, b) => b.value - a.value);

        const cats = items.map(i => AiCheckMissingFields[i.key]);
        const vals = items.map(i => i.value);
        const cols = items.map(i => (i.value >= threshold ? "#dc3545" : "#0d6efd"));

        return { categories: cats, values: vals, colors: cols };

    }, [missingData, threshold]);

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
            animations: { enabled: true }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "60%",
                distributed: true
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return `${val}%`;
            },
            style: {
                fontSize: "12px"
            }
        },
        xaxis: {
            categories,
            max: 100,
            labels: {
                formatter: function (val) {
                    return `${val}%`;
                },
                style: {
                    fontSize: "14px"
                }
            },
            title: {
                text: t("Missing Percentage"),
                style: {
                    fontSize: "14px"
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: "14px",
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return `${val}% ${t('missing')}`;
                }
            }
        },
        colors,
        grid: {
            borderColor: "#e9ecef"
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: {
                        bar: {
                            barHeight: "50%"
                        },
                    },
                    dataLabels: {
                        style: {
                            fontSize: "11px"
                        }
                    }
                }
            }
        ]
    };

    const series = [
        {
            name: `${t('Missing')} %`,
            data: values
        }
    ];

    return (
        <Card className="h-100">
            <CardBody>
                <CardTitle tag="h6" className="mb-3">
                    <span className="me-1">
                        {`${t(title)} (%)`}
                    </span>
                    <i
                        className="ri-information-line"
                        style={{
                            cursor: 'pointer'
                        }}
                        id={id}
                    />

                    <UncontrolledTooltip
                        target={id}
                    >
                        {t(helpText)}
                    </UncontrolledTooltip>
                </CardTitle>

                {values.length === 0 ? (
                    <div className="text-muted">
                        {t('No data available.')}
                    </div>
                ) : (
                    <Chart
                        options={options}
                        series={series}
                        type="bar"
                        height={Math.max(200, values.length * 48)}
                    />
                )}
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    MissingChart
);
